module.exports = __webpack_public_path__ + "img/whatsapp.509cd30f.svg";